import { ApplyPromocodeService } from 'types/services';
import { m8API } from '../m8';

export const applyPromocode: ApplyPromocodeService = async (promocode) => {
  await m8API.user.applyPromocode({ promocode });
};
